import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';
import "../string.extensions";

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var i18nVS: any;
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var urlServiceInformation: any; // URL dinamica para que Funcione tanto en Liferay como en VSC
declare var GetTarifaArticleURL: any; // URL dinamica para que Funcione tanto en Liferay como en VSC
declare var idModoTarifaLiferay: any;
declare var idiomaLiferay: any; // El idioma que tiene el usuario seleccionado
declare var portletNameServiceInformationLiferay: any; // Nombre del portlet en Liferay

declare var colorLineaClicada: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;

declare var tarifasJsonData: any;

@Component({
    selector: 'app-service-information-tarifas',
    templateUrl: './tarifas.component.html',
    styleUrls: ['../service-information.component.css']
})

export class TarifasComponent {
/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = i18nVS;
    idModoTarifa = 0; // 0 para toda la ciudad, 1 por linea, 2 tarifa multiple
    idioma = 'ar_SA';

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();

    idLinea = '';
    origen = '';
    destino = '';
    colorLinea = '#FF0000';
    nombreLinea = '';
    jsonData;

    tarifaNormal = '-';
    tarifaIklas = '-';
    tarifaTransbordo = '-';
    tarifaIdaVuelta = '-';
    tarifaTransbordos =  '';

    tarifaEstandarClass = '';
    tarifaMultipleClass = 'invisible';

    portletName = ''; // Nombre del portlet

    zonasFinal = [];
    codigosTarifa = [];
    codigosTarifaIkhlas = [];
    i18nTarifaTitulo = this.i18nL.serviceInformation_tarifaNormal;
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public setTraducciones() {
    	this.i18nTarifaTitulo = this.i18nL.serviceInformation_tarifaNormal;
    }

    public RecogerTarifa() { // Recoge las lineas de un JSON
        this.leerDatos().subscribe(res => this.comprobandoJson(res), (err) => this.errorEnElJson(), () => this.ObetenerHTML());
    }

    public comprobandoJson (res) {
        try {
            this.jsonData = res;
            tarifasJsonData = this.jsonData;
        } catch (error) {
            this.errorEnElJson();
        }
    }

    leerDatos(): Observable<Response> {
        const body = this.portletName + "cityId=" + idCiudadLiferay + "&" + this.portletName + "lineId=" + this.idLinea + "&" + this.portletName + "idModoTarifa=" + this.idModoTarifa;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this.http.post(GetTarifaArticleURL, body, httpOptions);
    }

    public filtrarTarifas(idLinea) {
        if (idLinea !== -1) {
            this.nombreLinea = 'Id linea: ' + idLinea;
        } else {
            this.nombreLinea = '';
        }
    }

    public PoblarOrigenDestino(origen, destino) {
        this.origen = origen;
        this.destino = destino;
    }

    public PoblarVariables(idLinea) {
        this.colorLinea = colorLineaClicada;
        this.origen = nombreOrigen;
        this.destino = nombreDestino;
        this.idLinea = idLinea;
        if (typeof idModoTarifaLiferay !== 'undefined') {
            this.idModoTarifa = idModoTarifaLiferay;
        }
        this.RecogerTarifa();
        this.setTraducciones();
    }

    public ObetenerHTML() {
        if (this.jsonData.tarifa.length > 1) {
            this.idModoTarifa = 2;
        }

        if (this.idModoTarifa === 0) {
            this.tarifaNormal = (this.jsonData.tarifa[0].normal as string).reformat();
            this.tarifaIklas = (this.jsonData.tarifa[0].ikhlas as string).reformat();
            this.tarifaIdaVuelta = (this.jsonData.tarifa[0].idaVuelta as string).reformat();

            this.tarifaEstandarClass = '';
            this.tarifaTransbordos = 'invisible';
            this.tarifaMultipleClass = 'invisible';

            this.i18nTarifaTitulo = this.i18nL.serviceInformation_tarifaParaLaCiudad;
        } else {
            if (this.idModoTarifa === 1) {
                this.tarifaNormal = (this.jsonData.tarifa[0].normal as string).reformat();
                this.tarifaIklas = (this.jsonData.tarifa[0].ikhlas as string).reformat();
                this.tarifaTransbordo = (this.jsonData.tarifa[0].transbordos as string).reformat();
                this.tarifaIdaVuelta = (this.jsonData.tarifa[0].idaVuelta as string).reformat();

                this.tarifaEstandarClass = '';
                this.tarifaTransbordos = '';
                this.tarifaMultipleClass = 'invisible';

                this.i18nTarifaTitulo = this.i18nL.serviceInformation_tarifaSimple;
            } else {
                if (this.idModoTarifa === 2) {
                    console.log('Tercer modo de tarifa');
                    this.tarifaEstandarClass = 'invisible';
                    this.tarifaTransbordos = '';
                    this.tarifaMultipleClass = '';
                    this.ObetenerTarifasMultiples();

                    this.i18nTarifaTitulo = this.i18nL.serviceInformation_tarifaMultiple;
                }
            }
        }
    }

    public ObetenerTarifasMultiples() {
        if (typeof idiomaLiferay !== 'undefined') {
            this.idioma = idiomaLiferay;
        }
        if (this.idioma !== 'ar_SA') {
            this.zonasFinal = this.jsonData.tarifa[1].barrios_fr_FR.split(',');
        } else {
            this.zonasFinal = this.jsonData.tarifa[0].barrios_ar_SA.split(',');
        }
    }

    public setValuesOnSpans() {
        if (typeof this.jsonData.tarifa[2] !== 'undefined') {

            // Se insertan los valores de las tarifas estandar
            this.codigosTarifa = this.jsonData.tarifa[2].codigo.split(',');
            for (var t = 0; t < this.codigosTarifa.length; t++) {
                var numeros = this.codigosTarifa[t].split('-');
                var idInputTarifa = 'TarifaMultiple' + numeros[0] + '' + numeros[1];
                if ((<HTMLInputElement>document.getElementById(idInputTarifa)) !== null) {
                    (<HTMLInputElement>document.getElementById(idInputTarifa)).innerText = numeros[2];
                }
            }

            // Se insertan los valores de las tarifas ikhlas
            this.codigosTarifaIkhlas = this.jsonData.tarifa[3].codigoIkhlas.split(',');
            for (var z = 0; z < this.codigosTarifaIkhlas.length; z++) {
                var numerosIkhlas = this.codigosTarifaIkhlas[z].split('-');
                var idInputTarifaIkhlas = 'TarifaMultipleIkhlas' + numerosIkhlas[0] + '' + numerosIkhlas[1];
                if ((<HTMLInputElement>document.getElementById(idInputTarifaIkhlas)) !== null) {
                    (<HTMLInputElement>document.getElementById(idInputTarifaIkhlas)).innerText = numerosIkhlas[2];
                }
            }
        }
    }

    public errorEnElJson() {
        console.log('Error en los WS');
        this.onWebServiceError.emit(true);
    }

    public invisibilizar (posicion) {
        var clase = '';
        if (posicion === 0) {
            clase = 'invisible';
        }
        return clase;
    }

    ngOnInit() {
        this.portletName = portletNameServiceInformationLiferay;
    }
    /*--------------------------------------------- Eventos ------------------------------------------------------*/

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(HttpClient) private http, private _sanitizer: DomSanitizer) { }
}



// WEBPACK FOOTER //
// ./src/app/tarifas/tarifas.component.ts